<router-outlet></router-outlet>

<!-- <cigna-trust *ngIf="trustEnabled$ | async"></cigna-trust> -->
